<section id="home" class="slider_area">
    <div id="carouselThree" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselThree" data-slide-to="0" class="active"></li>
            <li data-target="#carouselThree" data-slide-to="1"></li>
            <li data-target="#carouselThree" data-slide-to="2"></li>
            <li data-target="#carouselThree" data-slide-to="3"></li>
            <li data-target="#carouselThree" data-slide-to="4"></li>
        </ol>
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="container">
                    <div class="row align-items-center flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'HOME.MAIN_TITLE1' | translate }} </h1>
                                <p class="text white">{{ 'HOME.MAIN_SUBTITLE1' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/1.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-item">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'HOME.MAIN_TITLE2' | translate }}</h1>
                                <p class="text">{{ 'HOME.MAIN_SUBTITLE2' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/2.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-item">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'HOME.MAIN_TITLE3' | translate }}</h1>
                                <p class="text">{{ 'HOME.MAIN_SUBTITLE3' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/3.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-item">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'HOME.MAIN_TITLE4' | translate }}</h1>
                                <p class="text">{{ 'HOME.MAIN_SUBTITLE4' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/4.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-item">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{ 'HOME.MAIN_TITLE5' | translate }}</h1>
                                <p class="text">{{ 'HOME.MAIN_SUBTITLE5' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/5.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <a class="carousel-control-prev" href="#carouselThree" role="button" data-slide="prev">
            <i class="lni lni-arrow-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselThree" role="button" data-slide="next">
            <i class="lni lni-arrow-right"></i>
        </a>
    </div>
</section>

<section id="how-it-works" class="how-it-works-area">
    <div class="container">
        <div class="section-title text-center">
            <h2>{{ 'HOME.HOW_IT_WORKS_PRICE_TITLE' | translate }}</h2>
            <p>{{ 'HOME.HOW_IT_WORKS_PRICE_TEXT' | translate }}</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-4">
                <div class="collaboration-card">
                    <div class="card-icon">
                        <i class="lni lni-home"></i>
                    </div>
                    <div class="card-content">
                        <h3>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_TITLE' | translate }}</h3>
                        <p>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_TEXT' | translate }}</p>
                        <ul class="feature-list">
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F1' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F2' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F3' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F4' |
                                translate }}</li>
                        </ul>
                        <a href="{{assistantHref}}/register" target="_blank" class="action-btn">
                            {{ 'HOME.USER_REGISTER' | translate }} <i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="collaboration-card">
                    <div class="card-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <div class="card-content">
                        <h3>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_TITLE' | translate }}</h3>
                        <p>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_TEXT' | translate }}</p>
                        <ul class="feature-list">
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F1' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F2' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F3' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F4' |
                                translate }}</li>
                        </ul>
                        <a href="{{assistantHref}}/register" target="_blank" class="action-btn">
                            {{ 'HOME.USER_REGISTER' | translate }} <i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="collaboration-card highlight">
                    <div class="card-badge">TRIAL</div>
                    <div class="card-icon">
                        <i class="lni lni-rocket"></i>
                    </div>
                    <div class="card-content">
                        <h3>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_TITLE' | translate }}</h3>
                        <p>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_TEXT' | translate }}</p>
                        <ul class="feature-list">
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F1' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F2' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F3' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F4' |
                                translate }}</li>
                        </ul>
                        <a href="{{assistantHref}}/register" target="_blank" class="action-btn">
                            {{ 'HOME.USER_REGISTER' | translate }} <i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center mt-4">
            <div class="col-lg-6">
                <div class="collaboration-card">
                    <div class="card-icon">
                        <i class="lni lni-control-panel"></i>
                    </div>
                    <div class="card-content">
                        <h3>{{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_TITLE' | translate }}</h3>
                        <p>{{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_TEXT' | translate }}</p>
                        <ul class="feature-list">
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_F1' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_F2' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_F3' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_F4' |
                                translate }}</li>
                        </ul>
                        <a href="/collaboration#contact" target="_blank" class="action-btn">
                            {{ 'HOME.USER_LEARN_MORE' | translate }} <i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="collaboration-card">
                    <div class="card-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <div class="card-content">
                        <h3>{{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_TITLE' | translate }}</h3>
                        <p>{{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_TEXT' | translate }}</p>
                        <ul class="feature-list">
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_F1' |
                                translate }}
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_F2' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_F3' |
                                translate }}</li>
                            <li><i class="lni lni-checkmark-circle"></i> {{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_F4' |
                                translate }}</li>
                        </ul>
                        <a href="/collaboration#contact" target="_blank" class="action-btn">
                            {{ 'HOME.USER_DISCOVER_SOLUTION' | translate }} <i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Widget-uri informative -->
        <div class="row justify-content-center mt-5">
            <div class="col-lg-6">
                <div class="info-widget stats-widget">
                    <div class="widget-header">
                        <i class="fas fa-chart-line"></i>
                        <h4>{{ 'HOME.STATISTICS' | translate }}</h4>
                    </div>
                    <div class="widget-content">
                        <div class="items-container">
                            <div class="stat-item">
                                <i class="fas fa-users"></i>
                                <div class="support-text">
                                    <h5>{{ 'HOME.STATISTICS_ACTIVE_CLIENTS' | translate }}</h5>
                                    <p>{{ 'HOME.STATISTICS_ACTIVE_CLIENTS_TEXT' | translate }}</p>
                                </div>
                            </div>
                            <div class="stat-item">
                                <i class="fas fa-building"></i>
                                <div class="support-text">
                                    <h5>{{ 'HOME.STATISTICS_MANAGED_PROPERTIES' | translate }}</h5>
                                    <p>{{ 'HOME.STATISTICS_MANAGED_PROPERTIES_TEXT' | translate }}</p>
                                </div>
                            </div>
                            <div class="stat-item">
                                <i class="fas fa-chart-bar"></i>
                                <div class="support-text">
                                    <h5>{{ 'HOME.STATISTICS_SUCCESS_RATE' | translate }}</h5>
                                    <p>{{ 'HOME.STATISTICS_SUCCESS_RATE_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="widget-footer">
                            <a href="#" class="action-btn">
                                {{ 'HOME.STATISTICS_SEE_MORE' | translate }}
                                <i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="info-widget support-widget">
                    <div class="widget-header">
                        <i class="fas fa-headset"></i>
                        <h4>{{ 'HOME.DEDICATED_SUPPORT' | translate }}</h4>
                    </div>
                    <div class="widget-content">
                        <div class="items-container">
                            <div class="support-item">
                                <i class="fas fa-clock"></i>
                                <div class="support-text">
                                    <h5>{{ 'HOME.DEDICATED_SUPPORT_TITLE_1' | translate }}</h5>
                                    <p>{{ 'HOME.DEDICATED_SUPPORT_TEXT_1' | translate }}</p>
                                </div>
                            </div>
                            <div class="support-item">
                                <i class="fas fa-comments"></i>
                                <div class="support-text">
                                    <h5>{{ 'HOME.DEDICATED_SUPPORT_TITLE_2' | translate }}</h5>
                                    <p>{{ 'HOME.DEDICATED_SUPPORT_TEXT_2' | translate }}</p>
                                </div>
                            </div>
                            <div class="support-item">
                                <i class="fas fa-graduation-cap"></i>
                                <div class="support-text">
                                    <h5>Training și Resurse</h5>
                                    <p>Acces la materiale educaționale și ghiduri practice</p>
                                </div>
                            </div>
                        </div>
                        <div class="widget-footer">
                            <a href="/main#contact" class="action-btn">
                                Contactează suportul
                                <i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="services" class="features-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'HOME.OFFERED_SOLUTIONS' | translate }}</h3>
                    <p class="text">{{ 'HOME.OFFERED_SOLUTIONS_DETAILS' | translate }} </p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-island"></i>
                        </div>
                        <h4 class="features-title"><a routerLink="/solution1">
                                {{ 'HOME.FEATURE_AUTOMATE_OPERATIONS_TITLE' | translate }}
                            </a>
                        </h4>
                    </div>
                    <div class="features-content">
                        <p class="text tooltip-text-content">
                            {{ 'HOME.FEATURE_AUTOMATE_OPERATIONS_TEXT' | translate }}
                        </p>
                        <a class="features-btn" routerLink="/solution1">{{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-layout"></i>
                        </div>
                        <h4 i18n="@@featureCollectPaymentsOnlineTitle" class="features-title"><a
                                routerLink="/solution2">
                                {{ 'HOME.FEATURE_COLLECT_PAYMENTS_ONLINE_TITLE' | translate }}
                            </a>
                        </h4>

                    </div>
                    <div class="features-content">
                        <p i18n="@@featureCollectPaymentsOnlineText" class="text tooltip-text-content"> {{
                            'HOME.FEATURE_COLLECT_PAYMENTS_ONLINE_TEXT' | translate }}</p>
                        <a class="features-btn" routerLink="/solution2"> {{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-write"></i>
                        </div>
                        <h4 i18n="@@featureProfessionalReportTitle" class="features-title">
                            <a routerLink="/solution3"> {{
                                'HOME.FEATURE_PROFESSIONAL_REPORT_TITLE' | translate }}</a>
                        </h4>

                    </div>
                    <div class="features-content">
                        <p i18n="@@featureProfessionalReportText" class="text tooltip-text-content"> {{
                            'HOME.FEATURE_PROFESSIONAL_REPORT_TEXT' | translate }}</p>
                        <a i18n="@@featureWantDetails" class="features-btn" routerLink="/solution3"> {{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-shield"></i>
                        </div>
                        <h4 class="features-title">
                            <a routerLink="/solution4">
                                {{
                                'HOME.FEATURE_SCORING_TITLE' | translate }}
                            </a>
                        </h4>
                    </div>
                    <div class="features-content">
                        <p class="text tooltip-text-content">
                            {{
                            'HOME.FEATURE_SCORING_TEXT' | translate }}
                        </p>
                        <a class="features-btn" routerLink="/solution4">{{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-files"></i>
                        </div>
                        <h4 class="features-title"><a routerLink="/solution5">
                                {{
                                'HOME.FEATURE_INVENTORY_TITLE' | translate }}
                            </a></h4>

                    </div>
                    <div class="features-content">
                        <p class="text tooltip-text-content">
                            {{
                            'HOME.FEATURE_INVENTORY_TEXT' | translate }}
                        </p>
                        <a class="features-btn" routerLink="/solution5">{{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-7 col-sm-9 mt-40">
                <div class="single-features">
                    <div class="features-title-icon d-flex justify-content-between">
                        <div class="features-icon">
                            <i class="lni lni-bolt"></i>
                        </div>
                        <h4 class="features-title"><a routerLink="/solution6">
                                {{
                                'HOME.FEATURE_UTILITIES_TITLE' | translate }}
                            </a></h4>
                    </div>
                    <div class="features-content">
                        <p class="text tooltip-text-content">
                            {{
                            'HOME.FEATURE_UTILITIES_TEXT' | translate }}
                        </p>
                        <a class="features-btn" routerLink="/solution6">{{
                            'HOME.FEATURE_WANT_DETAILS' | translate }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="pricing" class="pricing-area gray-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-25">
                    <h3 class="title">{{ 'HOME.SECTION_PAYMENT_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_PAYMENT_TEXT' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 col-md-7 col-sm-9 mt-30">
                <div class="pricing-style">
                    <div class="pricing-icon text-center">
                        <img src="assets/images/payment/start.png" alt="">
                    </div>
                    <div class="pricing-header text-center">
                        <h5 class="sub-title">{{ 'HOME.START_TITLE' | translate }}</h5>
                        <div class="recommended-badge">{{ 'HOME.START_TEXT' | translate }}</div>
                        <p>
                            <span class="month"
                                *ngIf="getSubscriptionPriceDetails('start_subscription_monthly') as start_subscription_monthly">
                                {{ start_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                start_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                {{ 'HOME.START_PRICE' | translate }}
                            </span>
                        </p>
                    </div>
                    <div class="pricing-list">
                        <div class="plan-description">
                            <p>{{ 'HOME.START_FUNCTIONALITY_TEXT' | translate }}</p>
                        </div>
                        <ul class="item-list">
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM1_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM2_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM3_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM4_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM5_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.START_ITEM6_TEXT' | translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.START_ITEM7_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.START_ITEM8_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.START_ITEM9_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.START_ITEM10_TEXT' | translate }}
                            </li>
                        </ul>
                    </div>
                    <div>
                        <a href="/pricing" class="action-btn">
                            {{ 'HOME.START_BUTTON' | translate }}<i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-7 col-sm-9 mt-30">
                <div class="pricing-style">
                    <div class="pricing-icon text-center">
                        <img src="assets/images/payment/smart.png" alt="">
                    </div>
                    <div class="pricing-header text-center">
                        <h5 class="sub-title">{{ 'HOME.SMART_TITLE' | translate }}</h5>
                        <div class="recommended-badge">{{ 'HOME.SMART_TEXT' | translate }}</div>
                        <p>
                            <span class="month"
                                *ngIf="getSubscriptionPriceDetails('smart_subscription_monthly') as smart_subscription_monthly">
                                {{ smart_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                smart_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                {{ 'HOME.SMART_PRICE' | translate }}
                            </span>
                        </p>
                    </div>
                    <div class="pricing-list">
                        <div class="plan-description">
                            <p>{{ 'HOME.SMART_FUNCTIONALITY_TEXT' | translate }}</p>
                        </div>
                        <ul class="item-list">
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM1_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM2_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM3_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM4_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM5_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM6_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SMART_ITEM7_TEXT' | translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.SMART_ITEM8_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.SMART_ITEM9_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.SMART_ITEM10_TEXT' | translate }}
                            </li>
                        </ul>
                    </div>
                    <div>
                        <a href="/pricing" class="action-btn">
                            {{ 'HOME.SMART_BUTTON' | translate }}<i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-7 col-sm-9 mt-30">
                <div class="pricing-style">
                    <div class="pricing-icon text-center">
                        <img src="assets/images/payment/scale.png" alt="">
                    </div>
                    <div class="pricing-header text-center">
                        <h5 class="sub-title">{{ 'HOME.SCALE_TITLE' | translate }}</h5>
                        <div class="recommended-badge">{{ 'HOME.SCALE_TEXT' | translate }}</div>
                        <p>
                            <span class="month"
                                *ngIf="getSubscriptionPriceDetails('scale_subscription_monthly') as scale_subscription_monthly">
                                {{ scale_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                scale_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                {{ 'HOME.SCALE_PRICE' | translate }}
                            </span>
                        </p>
                    </div>
                    <div class="pricing-list">
                        <div class="plan-description">
                            <p>{{ 'HOME.SCALE_FUNCTIONALITY_TEXT' | translate }}</p>
                        </div>
                        <ul class="item-list">
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM1_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM2_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM3_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM4_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM5_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM6_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM7_TEXT' | translate }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.SCALE_ITEM8_TEXT' | translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.SCALE_ITEM9_TEXT' | translate }}
                            </li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.SCALE_ITEM10_TEXT' | translate }}
                            </li>
                        </ul>

                    </div>
                    <div>
                        <a href="/pricing" class="action-btn">
                            {{ 'HOME.SCALE_BUTTON' | translate }}<i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-7 col-sm-9 mt-30">
                <div class="pricing-style premium">
                    <div class="pricing-icon text-center">
                        <img src="assets/images/payment/premium.png" alt="">
                    </div>
                    <div class="pricing-header text-center">
                        <h5 class="sub-title">{{ 'HOME.MANAGEMENT_PROPERO_TITLE' | translate }}</h5>
                        <div class="recommended-badge">{{ 'HOME.MANAGEMENT_PROPERO_TEXT' | translate }}</div>
                        <p>
                            <span class="month">{{ 'HOME.MANAGEMENT_PROPERO_PRICE' | translate }}</span>
                        </p>
                    </div>
                    <div class="pricing-list">
                        <div class="plan-description">
                            <p>{{ 'HOME.MANAGEMENT_PROPERO_FUNCTIONALITY_TEXT' | translate }}</p>
                        </div>
                        <ul class="item-list">
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM1_TEXT' | translate
                                }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM2_TEXT' | translate
                                }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM3_TEXT' | translate
                                }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM4_TEXT' | translate
                                }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM5_TEXT' | translate
                                }}</li>
                            <li><span class="item">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM6_TEXT' | translate
                                }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM7_TEXT' |
                                translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM8_TEXT' |
                                translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM10_TEXT' |
                                translate }}</li>
                            <li><span class="item highlight">&#10003;</span> {{ 'HOME.MANAGEMENT_PROPERO_ITEM11_TEXT' |
                                translate }}</li>
                        </ul>
                    </div>
                    <div>
                        <a href="/collaboration#contact" class="action-btn">
                            {{ 'HOME.MANAGEMENT_PROPERO_BUTTON' | translate }}<i class="lni lni-arrow-right"></i>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<section id="resources" class="portfolio-area portfolio-four pb-100 white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-25">
                    <h3 i18n="@@sectionResourcesTitle" class="title"> {{ 'HOME.SECTION_RESOURCES_TITLE' |
                        translate }}</h3>
                    <p i18n="@@sectionResourcesText" class="text"> {{ 'HOME.SECTION_RESOURCES_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/fiscal-guide"> {{
                                'HOME.FISCAL_GUIDE_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-calculator"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.FISCAL_GUIDE_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/fiscal-guide" class="portfolio-btn"> {{
                                'HOME.LEARN_MORE' | translate }}</a>
                        </div>
                    </div>
                </div>

                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/help"> {{
                                'HOME.HELP_CENTER_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-support"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.HELP_CENTER_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/help" class="portfolio-btn"> {{
                                'HOME.ACCESS' | translate }}</a>
                        </div>
                    </div>
                </div>

                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/management-tool"> {{
                                'HOME.MANAGEMENT_TOOL_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-dashboard"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.PERFORMANCE_DASHBOARD_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/management-tool" class="portfolio-btn"> {{
                                'HOME.ACCESS_DASHBOARD' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/documents"> {{
                                'HOME.DOCUMENTS_AND_TEMPLATES_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-files"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.DOCUMENTS_AND_TEMPLATES_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/documents" class="portfolio-btn"> {{
                                'HOME.ORGANIZE' | translate }}</a>
                        </div>
                    </div>
                </div>

                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/calculators"> {{
                                'HOME.CALCULATORS_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-calculator"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.CALCULATORS_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/calculators" class="portfolio-btn"> {{
                                'HOME.CALCULATE' | translate }}</a>
                        </div>
                    </div>
                </div>

                <div class="single-portfolio">
                    <div class="portfolio-title-icon">
                        <div class="portfolio-title">
                            <a href="/todo"> {{
                                'HOME.TODO_LISTS_TITLE' | translate }}</a>
                        </div>
                        <div class="portfolio-icon">
                            <i class="lni lni-checkbox"></i>
                        </div>
                    </div>
                    <div class="portfolio-content">
                        <p class="text"> {{
                            'HOME.TODO_LISTS_TEXT' | translate }}
                        </p>
                        <div class="portfolio-btn-wrapper">
                            <a href="/todo" class="portfolio-btn"> {{
                                'HOME.CREATE_LISTS' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="blog" class="blog-area blog-five pb-100 gray-area">
    <div class="container">

        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-25">
                    <h3 i18n="@@sectionResourcesTitle" class="title">{{ 'HOME.SECTION_BLOG_TITLE' | translate }}
                    </h3>
                    <p i18n="@@sectionResourcesText" class="text">{{ 'HOME.SECTION_BLOG_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-8 col-sm-10" *ngFor="let blogItem of latestBlogItems">
                <div class="single-blog blog-style-one">
                    <div class="blog-image">
                        <button routerLink="/blog-post" [queryParams]="{id: blogItem.id}">
                            <img [src]="blogItem.imageURL || '../assets/images/blog/1.jpg'" alt="Blog" />
                        </button>
                        <a routerLink="/blog-post" [queryParams]="{id: blogItem.id}" class="category">{{
                            blogItem.BlogCategory.name || 'HOME.NO_CATEGORY' | translate
                            }}</a>
                    </div>
                    <div class="blog-content">
                        <div class="blog-title">
                            <a routerLink="/blog-post" [queryParams]="{id: blogItem.id}">
                                <h3>{{ blogItem.title }}</h3>
                            </a>
                        </div>
                        <span><i class="lni lni-calendar"></i> {{ blogItem.publishedDate | date: 'dd MMM yyyy' }}</span>
                        <span><i class="lni lni-comments-alt"></i> {{ blogItem.commentsCount || 0 }} {{
                            'HOME.COMMENTS' | translate }}</span>
                        <p class="text">{{ blogItem.summary || 'HOME.BLOG_NO_SUMMARY' | translate }}</p>
                        <a class="more" routerLink="/blog-post" [queryParams]="{id: blogItem.id}"> {{
                            'HOME.READ_MORE' | translate }}</a>
                    </div>
                </div>
                <!-- single blog -->
            </div>
        </div>
        <!-- row -->


        <!-- 
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-blog blog-style-one">
                    <div class="blog-image">
                        <a href="javascript:void(0)"><img src="../assets/images/blog/1.jpg" alt="Blog" /></a>
                        <a href="javascript:void(0)" class="category">Technology</a>
                    </div>
                    <div class="blog-content">
                        <h5 class="blog-title">
                            <a href="javascript:void(0)">
                                Budget-Friendly Design Ideas to Transform Your Office
                            </a>
                        </h5>
                        <span><i class="lni lni-calendar"></i> Mar 23, 2022</span>
                        <span><i class="lni lni-comments-alt"></i> 24 Comment</span>
                        <p class="text">
                            Create a workspace your team will love with these money-saving
                            interior Ui/Ux design tips Learn how People.
                        </p>
                        <a class="more" href="javascript:void(0)">READ MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-blog blog-style-one">
                    <div class="blog-image">
                        <a href="javascript:void(0)"><img src="../assets/images/blog/2.jpg" alt="Blog" /></a>
                        <a href="javascript:void(0)" class="category">Lifestyle</a>
                    </div>
                    <div class="blog-content">
                        <h5 class="blog-title">
                            <a href="javascript:void(0)">
                                Budget-Friendly Design Ideas to Transform Your Office
                            </a>
                        </h5>
                        <span><i class="lni lni-calendar"></i> Mar 23, 2022</span>
                        <span><i class="lni lni-comments-alt"></i> 24 Comment</span>
                        <p class="text">
                            Create a workspace your team will love with these money-saving
                            interior Ui/Ux design tips Learn how People.
                        </p>
                        <a class="more" href="javascript:void(0)">READ MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-blog blog-style-one">
                    <div class="blog-image">
                        <a href="javascript:void(0)"><img src="../assets/images/blog/3.jpg" alt="Blog" /></a>
                        <a href="javascript:void(0)" class="category">Science</a>
                    </div>
                    <div class="blog-content">
                        <h5 class="blog-title">
                            <a href="javascript:void(0)">
                                Budget-Friendly Design Ideas to Transform Your Office
                            </a>
                        </h5>
                        <span><i class="lni lni-calendar"></i> Mar 23, 2022</span>
                        <span><i class="lni lni-comments-alt"></i> 24 Comment</span>
                        <p class="text">
                            Create a workspace your team will love with these money-saving
                            interior Ui/Ux design tips Learn how People.
                        </p>
                        <a class="more" href="javascript:void(0)">READ MORE</a>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- row -->
    </div>
</section>

<section id="about" class="about-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="about-title">
                    <h6 class="sub-title">{{ 'HOME.SECTION_FAQ_TITLE' | translate }}</h6>
                    <h4 class="title">{{ 'HOME.SECTION_FAQ_TEXT' | translate }}</h4>
                </div>
                <div class="about-accordion">
                    <div class="accordion" id="accordionExample">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <a href="#" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne">
                                    {{ 'HOME.FEATURE_QUESTION1_TITLE' | translate }}
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="text">{{ 'HOME.FEATURE_QUESTION1_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseTwo"
                                    aria-expanded="false" aria-controls="collapseTwo">
                                    {{ 'HOME.FEATURE_QUESTION2_TITLE' | translate }}
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="text">{{ 'HOME.FEATURE_QUESTION2_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseThree"
                                    aria-expanded="false" aria-controls="collapseThree">
                                    {{ 'HOME.FEATURE_QUESTION3_TITLE' | translate }}
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="text">{{ 'HOME.FEATURE_QUESTION3_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingFour">
                                <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseFour"
                                    aria-expanded="false" aria-controls="collapseFour">
                                    {{ 'HOME.FEATURE_QUESTION4_TITLE' | translate }}
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="text">{{ 'HOME.FEATURE_QUESTION4_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingFive">
                                <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseFive"
                                    aria-expanded="false" aria-controls="collapseFive">
                                    {{ 'HOME.FEATURE_QUESTION5_TITLE' | translate }}
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="text">{{ 'HOME.FEATURE_QUESTION5_TEXT' | translate }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="contact-map">
                    <iframe 
                        src="https://maps.google.com/maps?q=brasov&t=&z=13&ie=UTF8&iwloc=&output=embed" 
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-1">
                    <div class="contact-info-icon">
                        <i class="lni lni-map-marker"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">Str. Calea București nr. 20<br>Sc B Ap 4<br>Brașov, Romania</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-2">
                    <div class="contact-info-icon">
                        <i class="lni lni-envelope"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">contact@propero.io</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-3">
                    <div class="contact-info-icon">
                        <i class="lni lni-phone"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">(+4) 0743 366 266</p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'HOME.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'HOME.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required email>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'HOME.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'HOME.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <button 
                                        type="submit"
                                        class="features-btn" 
                                        [disabled]="contactForm.invalid || isLoading"
                                        [ngClass]="{'loading': isLoading}"
                                    >
                                        <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                                        <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>